import React from "react";
import Navbar from "../components/Navbar";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { FaLeaf, FaBolt, FaLightbulb, FaMoneyBillWave } from "react-icons/fa";

const EnergySavings = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#542757] to-[#9b1f6c] text-white">
      <Navbar />

      <div className="max-w-6xl mx-auto px-6 py-16 mt-10">
        <motion.h1
          className="text-4xl font-extrabold text-center text-transparent bg-clip-text bg-gradient-to-r from-pink-500 to-yellow-400 mb-10 drop-shadow-lg"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          Energy Savings
        </motion.h1>

        <motion.p
          className="text-white/80 text-lg text-center mb-12"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2, duration: 0.6 }}
        >
          Discover how energy-efficient lighting can reduce your power bills, protect the environment, 
          and enhance your lifestyle — one bulb at a time.
        </motion.p>

        {/* Tips Grid */}
        <div className="grid md:grid-cols-2 gap-10">
          {/* Tip 1 */}
          <motion.div
            className="bg-white/10 rounded-2xl shadow-md p-6 hover:shadow-lg transition"
            whileHover={{ scale: 1.02 }}
          >
            <FaLightbulb className="text-yellow-400 text-4xl mb-4" />
            <h2 className="text-xl font-bold text-white mb-2">1. Switch to LED Lighting</h2>
            <p className="text-white/80">
              LED bulbs use up to 80% less energy than traditional incandescent bulbs. 
              They also last significantly longer, reducing replacement and maintenance costs.
            </p>
          </motion.div>

          {/* Tip 2 */}
          <motion.div
            className="bg-white/10 rounded-2xl shadow-md p-6 hover:shadow-lg transition"
            whileHover={{ scale: 1.02 }}
          >
            <FaBolt className="text-blue-400 text-4xl mb-4" />
            <h2 className="text-xl font-bold text-white mb-2">2. Use Smart Lighting Controls</h2>
            <p className="text-white/80">
              Integrate timers, sensors, and dimmers to automatically manage light levels based on 
              occupancy or daylight — cutting unnecessary power consumption.
            </p>
          </motion.div>

          {/* Tip 3 */}
          <motion.div
            className="bg-white/10 rounded-2xl shadow-md p-6 hover:shadow-lg transition"
            whileHover={{ scale: 1.02 }}
          >
            <FaMoneyBillWave className="text-green-400 text-4xl mb-4" />
            <h2 className="text-xl font-bold text-white mb-2">3. Lower Energy Bills</h2>
            <p className="text-white/80">
              With efficient fixtures and smarter lighting habits, you can significantly reduce your 
              monthly electricity expenses without compromising on brightness or comfort.
            </p>
          </motion.div>

          {/* Tip 4 */}
          <motion.div
            className="bg-white/10 rounded-2xl shadow-md p-6 hover:shadow-lg transition"
            whileHover={{ scale: 1.02 }}
          >
            <FaLeaf className="text-emerald-400 text-4xl mb-4" />
            <h2 className="text-xl font-bold text-white mb-2">4. Go Green & Sustainable</h2>
            <p className="text-white/80">
              Choose lighting products with recyclable materials and low environmental impact. 
              Your choices today contribute to a more sustainable tomorrow.
            </p>
          </motion.div>
        </div>

        {/* Call to Action */}
        <motion.div
          className="mt-16 text-center"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
        >
          <h3 className="text-2xl font-semibold text-white mb-3">
            Ready to Start Saving Energy?
          </h3>
          <p className="text-white/80 mb-6">
            Discover HLC’s premium range of energy-efficient LED products and make your home brighter, smarter, and greener.
          </p>
          {/* Filters the shop to LED Bulb Series (tip #1 above: "Switch to
              LED Lighting"), reusing the existing filtering system */}
          <button
            type="button"
            onClick={() => navigate("/shop", { state: { category: "LED BULB SERIES" } })}
            className="inline-block bg-gradient-to-r from-pink-500 to-yellow-400 text-white font-medium px-6 py-3 rounded-full shadow-md hover:shadow-lg transition"
          >
            Explore LED Solutions
          </button>
        </motion.div>
      </div>
    </div>
  );
};

export default EnergySavings;
